/**
 * List Sort direction enum, for using in general within the system.
 */
export enum SortDirection {
	ASC = "asc",
	DESC = "desc"
}
